const selfSet = {
  'pages.platform.user.staff.name': 'Staff Name',
}

export default selfSet
